"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var DialogContent_Props_1 = require("./DialogContent.Props");
var Modal_1 = require("../../Modal");
var withResponsiveMode_1 = require("../../utilities/decorators/withResponsiveMode");
var stylesImport = require("./Dialog.scss");
var styles = stylesImport;
var DialogContent_1 = require("./DialogContent");
var Dialog = (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this._getSubTextId = function () {
            var _a = _this.props, ariaDescribedById = _a.ariaDescribedById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, subText = _a.subText;
            var id = ariaDescribedById || (modalProps && modalProps.subtitleAriaId);
            if (!id) {
                id = (subText || (dialogContentProps && dialogContentProps.subText)) && _this._defaultSubTextId;
            }
            return id;
        };
        _this._getTitleTextId = function () {
            var _a = _this.props, ariaLabelledById = _a.ariaLabelledById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, title = _a.title;
            var id = ariaLabelledById || (modalProps && modalProps.titleAriaId);
            if (!id) {
                id = (title || (dialogContentProps && dialogContentProps.title)) && _this._defaultTitleTextId;
            }
            return id;
        };
        _this._id = Utilities_1.getId('Dialog');
        _this._defaultTitleTextId = _this._id + '-title';
        _this._defaultSubTextId = _this._id + '-subText';
        _this._warnDeprecations({
            'isOpen': 'hidden',
            'type': 'dialogContentProps.type',
            'subText': 'dialogContentProps.subText',
            'contentClassName': 'dialogContentProps.className',
            'topButtonsProps': 'dialogContentProps.topButtonsProps',
            'className': 'modalProps.className',
            'isDarkOverlay': 'modalProps.isDarkOverlay',
            'isBlocking': 'modalProps.isBlocking',
            'containerClassName': 'modalProps.containerClassName',
            'onDismissed': 'modalProps.onDismissed',
            'onLayerDidMount': 'modalProps.onLayerDidMount',
            'ariaDescribedById': 'modalProps.subtitleAriaId',
            'ariaLabelledById': 'modalProps.titleAriaId'
        });
        return _this;
    }
    Dialog.prototype.render = function () {
        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, isOpen = _a.isOpen, className = _a.className, onDismiss = _a.onDismiss, onDismissed = _a.onDismissed, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, subText = _a.subText, title = _a.title, type = _a.type, contentClassName = _a.contentClassName, topButtonsProps = _a.topButtonsProps, dialogContentProps = _a.dialogContentProps, modalProps = _a.modalProps, containerClassName = _a.containerClassName, hidden = _a.hidden;
        return (React.createElement(Modal_1.Modal, tslib_1.__assign({ elementToFocusOnDismiss: elementToFocusOnDismiss, firstFocusableSelector: firstFocusableSelector, forceFocusInsideTrap: forceFocusInsideTrap, ignoreExternalFocusing: ignoreExternalFocusing, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap, onDismissed: onDismissed, onLayerDidMount: onLayerDidMount, responsiveMode: responsiveMode }, modalProps, { isDarkOverlay: isDarkOverlay !== undefined ? isDarkOverlay : modalProps.isDarkOverlay, isBlocking: isBlocking !== undefined ? isBlocking : modalProps.isBlocking, isOpen: isOpen !== undefined ? isOpen : !hidden, className: Utilities_1.css('ms-Dialog', className ? className : modalProps.className), containerClassName: Utilities_1.css(styles.main, containerClassName ? containerClassName : modalProps.containerClassName), onDismiss: onDismiss ? onDismiss : modalProps.onDismiss, subtitleAriaId: this._getSubTextId(), titleAriaId: this._getTitleTextId() }),
            React.createElement(DialogContent_1.DialogContent, tslib_1.__assign({ titleId: this._defaultTitleTextId, subTextId: this._defaultSubTextId, title: title, subText: subText, showCloseButton: isBlocking !== undefined ? !isBlocking : !modalProps.isBlocking, topButtonsProps: topButtonsProps ? topButtonsProps : dialogContentProps.topButtonsProps, type: type !== undefined ? type : dialogContentProps.type, onDismiss: onDismiss ? onDismiss : dialogContentProps.onDismiss, className: Utilities_1.css(contentClassName ? contentClassName : dialogContentProps.className) }, dialogContentProps), this.props.children)));
    };
    Dialog.defaultProps = {
        modalProps: {
            isDarkOverlay: true,
            isBlocking: false,
            className: '',
            containerClassName: ''
        },
        dialogContentProps: {
            type: DialogContent_Props_1.DialogType.normal,
            className: '',
            topButtonsProps: [],
        },
        hidden: true,
    };
    Dialog = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], Dialog);
    return Dialog;
}(Utilities_1.BaseComponent));
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Dialog/Dialog.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Dialog/Dialog.js
// module chunks = 1